import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Card from "src/components/ui/Card";
import LoginForm from "src/components/forms/LoginForm";

import { getFromStorage, setToStorage } from "src/utils/storage";
import storageKeys from "src/constants/storage";
import * as authTenantActions from "src/redux/slices/authTenantSlice";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";

const LoginPage: React.FC = () => {
  const [apiError, setApiError] = useState("");

  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const { login } = useAppSelector((state) => state.authTenant);

  useEffect(() => {
    const authTenantToken = getFromStorage(storageKeys.authTenantToken);
    if (authTenantToken) {
      navigate("/app/dashboard");
    }
  }, []);

  useEffect(() => {
    if (login?.data?.token) {
      console.log("Login data:", login.data);
      // On successful login, redirect to tenant dashboard
      setToStorage(storageKeys.authTenantToken, login.data.token);
      dispatch(authTenantActions.getUserDetailsRequest());
      navigate("/app/dashboard");
    } else if (login?.error) {
      setApiError(login.error);
    }
  }, [login, navigate]);

  const handleSubmit = (
    data:
      | {
          email: string;
          password: string;
        }
      | any
  ) => {
    // Dispatch login action
    dispatch(authTenantActions.loginRequest(data));
  };

  return (
    <div className="min-h-screen flex bg-emerald-950">
      {/* Left Branding Section */}
      <div className="hidden lg:flex w-1/2 text-white flex-col justify-between p-12 relative overflow-hidden bg-gradient-to-br from-emerald-950 via-emerald-800 to-sky-500">
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1 text-xs uppercase tracking-[0.25em] text-emerald-100">
            Tenant Workspace
          </div>
          <div className="mt-6 text-4xl font-semibold tracking-tight">
            Storefront Ops Hub
          </div>
          <p className="mt-4 text-sm text-emerald-50 max-w-md">
            Track inventory, fulfill orders, and keep teams aligned in real time
            across every location.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-3 text-xs text-emerald-50">
            <div className="rounded-xl bg-white/15 p-3">Live stock pulse</div>
            <div className="rounded-xl bg-white/15 p-3">
              Sales & purchase flow
            </div>
            <div className="rounded-xl bg-white/15 p-3">Smart reorder cues</div>
            <div className="rounded-xl bg-white/15 p-3">
              Team performance view
            </div>
          </div>
        </div>
        {/* <div className="relative z-10 mt-10">
          <img
            src="/assets/tenant-login-visual.svg"
            alt="Inventory workflow overview"
            className="w-full max-w-md"
          />
        </div> */}
        <div className="absolute -top-24 right-0 h-64 w-64 rounded-full bg-emerald-400/25 blur-3xl" />
        <div className="absolute -bottom-24 left-0 h-72 w-72 rounded-full bg-sky-400/25 blur-3xl" />
      </div>

      {/* Right Login Form */}
      <div className="flex-1 flex items-center justify-center bg-emerald-50 p-6">
        <div className="w-full max-w-md">
          <Card>
            <div className="text-lg font-semibold text-center">
              Sign in to your workspace
            </div>
            <div className="text-sm text-gray-500 text-center mt-2 mb-4">
              Use the email assigned by your tenant admin.
            </div>

            {apiError && (
              <div className="bg-red-100 text-red-700 p-2 rounded mb-4 text-sm text-center">
                {apiError}
              </div>
            )}
            <LoginForm handleSubmit={handleSubmit} />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
